<div class="flex cursor-pointer mb-3" (click)="isModalVisible.set(!isModalVisible())">
  <div class="w-28 flex">
    @if (isTenantSelection()) {
      Tenant:
    } @else {
      Deployment:
    }
  </div>
  <div class="flex-1">
    {{ selectedName() }}
  </div>
  <div class="flex">
    <ods-ui-icon class="font-bold" [icon]="'ion:chevron-down-outline'"/>
  </div>
</div>

@if (isModalVisible() && !disabled()) {
  <ods-ui-modal
    [canDismiss]="!isModalVisible()"
    [focusOnShow]="true"
    [header]="isTenantSelection() ? 'Select Tenant' : 'Select Deployment'"
    [(isVisible)]="isModalVisible"
  >
    @if (this.searchData() && this.searchData().length! > 5) {
      <input #filter
             class="p-inputtext-sm"
             id="singleSelectFilterSearch"
             pInputText
             placeholder="Filter"
             type="text"
             (keyup)="filterList($event)"
      >
      <button aria-label="clear" pButton type="button" (click)="filter.value=''; filterList('');">
        <ods-ui-icon class="font-bold" [icon]="'ion:close-outline'"/>
      </button>
    }
    @for (item of filteredItems(); track item) {
      <div [ngClass]="'search-list-row cursor-pointer ' + item.className" (click)="setSelection(item)">
        [{{ item.id }}] {{ item.name }}
      </div>
    } @empty {
      <div class="row">
        No
        @if (isTenantSelection()) {
          tenants
        } @else {
          deployments
        }
        available to select
      </div>
    }
  </ods-ui-modal>
}
